import { Platform } from "react-native";
export const makeEbookLocatorCompatible = (locator) => {
    if (Platform.OS === "web") {
        if (locator.href.charAt(0) === "/") {
            locator.href = locator.href.slice(1);
        }
    }
    else {
        if (locator.href.charAt(0) !== "/") {
            locator.href = `/${locator.href}`;
        }
    }
    return locator;
};
//# sourceMappingURL=makeEbookLocatorCompatible.js.map